import clsx from 'clsx';
import React from 'react';
import { TW_RING } from '../../../../../domain/websiteDomain';
// import { Classification } from '../../../../../typescript/enums';
import { FetchSessionsMinimalQueryVariables } from '../../../../../typescript/generated/codegen';

interface ClassificationsProps {
  classifications: string[];
  filters: FetchSessionsMinimalQueryVariables;
  setFilters: (filters: FetchSessionsMinimalQueryVariables) => void;
}

const Classifications: React.FC<ClassificationsProps> = ({
  classifications,
  filters,
  setFilters,
}) => {
  const handleSetClassification = (classification: string) => {
    if (classifications.length > 1) {
      setFilters({
        ...filters,
        types: undefined,
        classifications: filters.classifications?.includes(classification)
          ? undefined
          : [classification],
      });
    }
  };

  // const options = [
  //   ...(classifications.length > 1 ? [ALL_CLASSIFICATIONS] : []),
  //   Classification.YOGA,
  //   Classification.PILATES,
  //   Classification.WORKSHOPS,
  //   Classification.FITNESS,
  //   Classification.MINDFULNESS,
  //   Classification.MUSIC,
  // ].filter(Boolean);

  return (
    <div
      className={clsx(
        'grid gap-2',
        [1, 2, 4].includes(classifications.length)
          ? 'grid-cols-2'
          : 'grid-cols-3'
      )}
    >
      {classifications.map(classification => {
        const isSelected = filters.classifications?.includes(classification);

        return (
          <button
            key={`filter-sidemodal-${classification}`}
            className={clsx(
              'text-black h-48px w-full text-center border border-accent-light rounded-full cursor-pointer',
              TW_RING,
              isSelected && 'bg-accent-light',
              !isSelected && 'hover:border-accent'
            )}
            style={{ minWidth: 100 }}
            onClick={() => handleSetClassification(classification)}
          >
            {classification === 'Mindfulness' ? 'Mind' : classification}
          </button>
        );
      })}
    </div>
  );
};

export default Classifications;
